import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Stack,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import { getData } from "../../../../services/library";
import { UrlApi } from "../../../../services/apirest";
import DefinicionVariable from "../../rangoPrecios/ActualizacionPrecio/DefinicionVariable";
import SelectorCategorias from "./SelectorCategorias";
import moment from "moment";

function ActualizarPreciosCategorias({ open, onClose, lista }) {
  const [step, setStep] = useState(1);

  const [sucursales, setSucursales] = useState([]);
  const [productos, setProductos] = useState([]);
  const [tiposCliente, setTiposCliente] = useState([]);

  const [sucursalesSeleccionadas, setSucursalesSeleccionadas] = useState([]);
  const [productosSeleccionados, setProductosSeleccionados] = useState([]);
  const [tiposSeleccionados, setTiposSeleccionados] = useState([]);

  const [monto, setMonto] = useState("");
  const [porcentaje, setPorcentaje] = useState("");
  const [precioMinimo, setPrecioMinimo] = useState("");
  const [precioMaximo, setPrecioMaximo] = useState("");
  const [tipoOperacion, setTipoOperacion] = useState("");
  const [guardando, setGuardando] = useState(false);

  const [openSnack, setOpenSnack] = useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [exito, setExito] = useState(false);

  useEffect(() => {
    const sucAuth = localStorage.getItem("suc_auth");
    getData(`/sucursales/xsucauth/${sucAuth}`, setSucursales);
    getData("/productos/envasados", setProductos);
    getData("/tipoclienteenvasado", setTiposCliente);
  }, []);

  const handleClose = () => {
    if (onClose) onClose();
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSnack(false);
    if (exito) handleClose();
  };

  const handleNext = () => {
    if (
      sucursalesSeleccionadas.length === 0 ||
      productosSeleccionados.length === 0 ||
      tiposSeleccionados.length === 0
    ) {
      setExito(false);
      setColorMensaje("#F1948A");
      setMensaje(
        "Seleccione al menos una sucursal, un producto y un tipo de cliente."
      );
      setOpenSnack(true);
      return;
    }
    setStep(2);
  };

  const handleBack = () => setStep(1);

  const validarInput = (value) => /^-?\d*\.?\d*$/.test(value);

  const handleMontoChange = (e) => {
    const value = e.target.value;
    if (validarInput(value)) {
      setMonto(value);
      if (value !== "") setPorcentaje("");
      setTipoOperacion("monto");
    }
  };

  const handlePorcentajeChange = (e) => {
    const value = e.target.value;
    if (validarInput(value)) {
      setPorcentaje(value);
      if (value !== "") setMonto("");
      setTipoOperacion("porcentaje");
    }
  };

  const handlePrecioMinimo = (e) => {
    const value = e.target.value;
    if (validarInput(value)) {
      setPrecioMinimo(value);
      if (value !== "") setMonto("");
      setTipoOperacion("precio");
    }
  };

  const handlePrecioMaximo = (e) => {
    const value = e.target.value;
    if (validarInput(value)) {
      setPrecioMaximo(value);
      if (value !== "") setMonto("");
      setTipoOperacion("precio");
    }
  };

  const calcularNuevos = (item) => {
    const valor = parseFloat(monto || porcentaje);
    let nuevoMin = Number(item.precio_minimo);
    let nuevoMax = Number(item.precio_maximo);

    if (tipoOperacion === "monto") {
      nuevoMin += valor;
      nuevoMax += valor;
    } else if (tipoOperacion === "porcentaje") {
      const factor = valor / 100;
      nuevoMin += nuevoMin * factor;
      nuevoMax += nuevoMax * factor;
    } else {
      nuevoMin = parseFloat(precioMinimo);
      nuevoMax = parseFloat(precioMaximo);
    }

    return {
      id: item.id,
      precio_minimo: Math.round(nuevoMin),
      precio_maximo: Math.round(nuevoMax),
      usuario: localStorage.getItem("user"),
    };
  };

  const handleGuardar = async (e) => {
    e.preventDefault();
    setGuardando(true);

    const listaFiltrada = (lista || []).filter(
      (item) =>
        sucursalesSeleccionadas.some((s) => s.id === item.id_sucursal) &&
        productosSeleccionados.some((p) => p.idproducto === item.id_producto) &&
        tiposSeleccionados.some((t) => t.id === item.id_tipocliente)
    );

    if (listaFiltrada.length === 0) {
      setGuardando(false);
      setExito(false);
      setColorMensaje("#F1948A");
      setMensaje("No hay rangos que coincidan con la selección.");
      setOpenSnack(true);
      return;
    }

    const listaActualizada = listaFiltrada.map(calcularNuevos);

    const invalido = listaActualizada.some(
      (r) =>
        isNaN(r.precio_minimo) ||
        isNaN(r.precio_maximo) ||
        r.precio_minimo > r.precio_maximo
    );
    if (invalido) {
      setGuardando(false);
      setExito(false);
      setColorMensaje("#F1948A");
      setMensaje(
        "Revise la variación: hay precios inválidos o mínimo mayor al máximo."
      );
      setOpenSnack(true);
      return;
    }

    try {
      const res = await fetch(UrlApi + "/envasado_rango_categorias/multiple", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(listaActualizada),
      });
      const data = await res.json();

      if (res.ok && data.message === "OK") {
        const historial = listaFiltrada.map((item, index) => {
          const actualizado = listaActualizada[index];
          return {
            id_producto: item.id_producto,
            id_sucursal: item.id_sucursal,
            id_tipocliente: item.id_tipocliente,
            precio_minimo_anterior: Number(item.precio_minimo),
            precio_maximo_anterior: Number(item.precio_maximo),
            precio_minimo_nuevo: actualizado.precio_minimo,
            precio_maximo_nuevo: actualizado.precio_maximo,
            fecha: moment().format("YYYY-MM-DD"),
            usuario: localStorage.getItem("user"),
          };
        });

        await fetch(
          UrlApi + "/envasado_historial_rango_categorias/multiple",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(historial),
          }
        );

        setExito(true);
        setColorMensaje("#D4EFDF");
        setMensaje(
          `Se actualizaron ${listaActualizada.length} rango(s) exitosamente !`
        );
        setOpenSnack(true);
      } else {
        setExito(false);
        setColorMensaje("#F1948A");
        setMensaje(data.message || "Error al actualizar los precios.");
        setOpenSnack(true);
        setGuardando(false);
      }
    } catch (err) {
      setExito(false);
      setColorMensaje("#F1948A");
      setMensaje("Error al conectar con la base de datos.");
      setOpenSnack(true);
      setGuardando(false);
    }
  };

  const isPrecioFijoValido = precioMinimo !== "" && precioMaximo !== "";
  const isVariacionValida =
    (monto !== "" || porcentaje !== "") && !isPrecioFijoValido;
  const isGuardarDisabled =
    guardando || exito || (!isPrecioFijoValido && !isVariacionValida);

  return (
    <>
      <Dialog open={open} onClose={handleClose} maxWidth={"md"} fullWidth>
        <form
          onSubmit={handleGuardar}
          style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}
        >
          <Box bgcolor="#1F618D">
            <DialogTitle
              sx={{
                bgcolor: "#1F618D",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                p: 1,
              }}
            >
              <Typography
                variant="h6"
                component="div"
                sx={{ flexGrow: 1, textAlign: "center" }}
              >
                Actualizar Precios - Paso {step}
              </Typography>
            </DialogTitle>
          </Box>

          <DialogContent sx={{ p: 1.8 }}>
            <Stepper activeStep={step - 1} alternativeLabel>
              <Step>
                <StepLabel>Seleccionar</StepLabel>
              </Step>
              <Step>
                <StepLabel>Ingresar variación</StepLabel>
              </Step>
            </Stepper>

            {step === 1 && (
              <SelectorCategorias
                sucursales={sucursales}
                productos={productos}
                tiposCliente={tiposCliente}
                sucursalesSeleccionadas={sucursalesSeleccionadas}
                setSucursalesSeleccionadas={setSucursalesSeleccionadas}
                productosSeleccionados={productosSeleccionados}
                setProductosSeleccionados={setProductosSeleccionados}
                tiposSeleccionados={tiposSeleccionados}
                setTiposSeleccionados={setTiposSeleccionados}
              />
            )}

            {step === 2 && (
              <DefinicionVariable
                monto={monto}
                porcentaje={porcentaje}
                precioMinimo={precioMinimo}
                precioMaximo={precioMaximo}
                handleMontoChange={handleMontoChange}
                handlePorcentajeChange={handlePorcentajeChange}
                handlePrecioMinimo={handlePrecioMinimo}
                handlePrecioMaximo={handlePrecioMaximo}
              />
            )}
          </DialogContent>

          <DialogActions sx={{ justifyContent: "space-between", p: 1 }}>
            <Button
              color="error"
              variant="contained"
              onClick={step === 1 ? handleClose : handleBack}
              sx={{ minWidth: 120 }}
            >
              Volver
            </Button>
            {step === 1 && (
              <Button
                variant="contained"
                color="primary"
                onClick={handleNext}
              >
                Siguiente
              </Button>
            )}
            {step === 2 && (
              <Button
                color="success"
                type="submit"
                variant="contained"
                sx={{ minWidth: 120 }}
                disabled={isGuardarDisabled}
              >
                Confirmar
              </Button>
            )}
          </DialogActions>
        </form>
      </Dialog>

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={2000}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity={exito ? "success" : "error"}
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default ActualizarPreciosCategorias;
